import Alert from "@visa/vds/alert";
import AlertIcon from "@visa/vds/alert-icon";
import AlertLabel from "@visa/vds/alert-label";
import AlertLabelTitle from "@visa/vds/alert-label-title";
import ButtonContainer from "@visa/vds/button-container";
import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Icon from "@visa/vds/icon";
import Link from "@visa/vds/link";
import Row from "@visa/vds/row";
import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { DafUploadRoutes } from "../../../../_constants/PageRoutes";

export const DafUploadSuccessMessage = (props) => {
  const history = useHistory();
  const clickHandler = () =>
    history.push({
      pathname: DafUploadRoutes.DAF_UPLOAD_REQUEST,
      state: { dafUpload: props.dafUpload },
    });

  const [showAlert, setShowAlert] = useState(true);
  return (
    <>
      <Alert
        alertType="success"
        id="alert-success-test"
        position="absolute"
        show={showAlert}
      >
        <Grid>
          <Row>
            <Col>
              <AlertIcon>
                <Icon name="success" resolution="low" />
              </AlertIcon>
              <AlertLabel>
                <AlertLabelTitle>Upload Success!</AlertLabelTitle>
                <Link
                  onClick={clickHandler}
                  inline
                  aria-label="View Uploaded File List"
                >
                  Click Here
                </Link>
                &nbsp; to view the Uploaded File.
              </AlertLabel>
            </Col>
            <Col sm={1}>
              <ButtonContainer>
                <ButtonGroup direction="right">
                  <ButtonText
                    onClick={() => {
                      setShowAlert(false);
                    }}
                    colorScheme="tertiary"
                  >
                    Dismiss
                  </ButtonText>
                </ButtonGroup>
              </ButtonContainer>
            </Col>
          </Row>
        </Grid>
      </Alert>
    </>
  );
};
